import { createContext } from 'react'

export const YearContext = createContext(2026)
